import { render, staticRenderFns } from "./ShippingRulesManager.vue?vue&type=template&id=5d11859f&scoped=true"
import script from "./ShippingRulesManager.vue?vue&type=script&lang=js"
export * from "./ShippingRulesManager.vue?vue&type=script&lang=js"
import style0 from "./ShippingRulesManager.vue?vue&type=style&index=0&id=5d11859f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11859f",
  null
  
)

export default component.exports